import { render, staticRenderFns } from "./LeadsFilterDatabase.vue?vue&type=template&id=c2809734&scoped=true"
import script from "./LeadsFilterDatabase.vue?vue&type=script&lang=js"
export * from "./LeadsFilterDatabase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2809734",
  null
  
)

export default component.exports